/* tslint:disable */
/* eslint-disable */
/**
 * acomo API docs
 * acomoのAPI仕様書です。
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GroupEntity } from './GroupEntity';
import {
    GroupEntityFromJSON,
    GroupEntityFromJSONTyped,
    GroupEntityToJSON,
    GroupEntityToJSONTyped,
} from './GroupEntity';

/**
 * 
 * @export
 * @interface ListGroupsResult
 */
export interface ListGroupsResult {
    /**
     * グループ一覧
     * @type {Array<GroupEntity>}
     * @memberof ListGroupsResult
     */
    groups: Array<GroupEntity>;
    /**
     * 総数
     * @type {number}
     * @memberof ListGroupsResult
     */
    total: number;
}

/**
 * Check if a given object implements the ListGroupsResult interface.
 */
export function instanceOfListGroupsResult(value: object): value is ListGroupsResult {
    if (!('groups' in value) || value['groups'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    return true;
}

export function ListGroupsResultFromJSON(json: any): ListGroupsResult {
    return ListGroupsResultFromJSONTyped(json, false);
}

export function ListGroupsResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListGroupsResult {
    if (json == null) {
        return json;
    }
    return {
        
        'groups': ((json['groups'] as Array<any>).map(GroupEntityFromJSON)),
        'total': json['total'],
    };
}

export function ListGroupsResultToJSON(json: any): ListGroupsResult {
    return ListGroupsResultToJSONTyped(json, false);
}

export function ListGroupsResultToJSONTyped(value?: ListGroupsResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'groups': ((value['groups'] as Array<any>).map(GroupEntityToJSON)),
        'total': value['total'],
    };
}

